import * as tslib_1 from "tslib";
import { NgModule } from '@angular/core';
import { MatIconModule, MatButtonModule, MatSnackBarModule, MatDialogModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DeleteDialogComponent } from './delete-dialog.componet';
var DeleteDialogModule = /** @class */ (function () {
    function DeleteDialogModule() {
    }
    DeleteDialogModule = tslib_1.__decorate([
        NgModule({
            imports: [
                MatIconModule,
                FlexLayoutModule,
                // Mat
                MatDialogModule,
                MatSnackBarModule,
                MatButtonModule
            ],
            declarations: [DeleteDialogComponent],
            exports: [DeleteDialogComponent],
            entryComponents: [DeleteDialogComponent]
        })
    ], DeleteDialogModule);
    return DeleteDialogModule;
}());
export { DeleteDialogModule };
//# sourceMappingURL=delete-dialog.module.js.map